import { companyDetails } from "translations";
import { LangProp } from "types";

function YearAndCompanyName({ lang }: LangProp) {
  const currentYear = String(new Date().getFullYear());
  const { name: companyName } = companyDetails[lang];

  return (
    <>
      <time dateTime={currentYear}>{currentYear}</time> © {companyName}
    </>
  );
}

export default YearAndCompanyName;
